import styled from 'styled-components'
import { Link } from 'gatsby'

import { FontLight, FontRegular, Breakpoints, Colors } from './../../utils/variables'

export const Item = styled.li`
    padding: 30px;

    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    &:first-of-type {
        padding-top: 0;
    }

    &:last-of-type {
        padding: 30px 30px 0 30px;
        
        border-bottom: none;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        padding: 50px 0;

        &:last-of-type {
            padding: 50px 0 0 0;
        }
    }
`

export const Content = styled.div`
    width: 100%;
    max-width: 700px; 

    margin: 0 auto;
`

export const Date = styled.span`
    display: block;

    margin-bottom: 10px;

    ${FontLight}
    font-size: 10px;
    letter-spacing: 1px;

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin-bottom: 10px;

        font-size: 11px;
        letter-spacing: 2px;
    }
`

export const Title = styled.h3`
    margin-bottom: 10px;

    ${FontRegular}
    font-size: 17px;
	line-height: 25px;

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin-bottom: 20px;

        font-size: 24px;
        line-height: 34px;
    }
`

export const Excerpt = styled.p`
    margin-bottom: 10px;

    ${FontLight}
    font-size: 13px;
    line-height: 17px;

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin-bottom: 20px;

        font-size: 17px;
        line-height: 27px;
    }
`

export const ReadMore = styled(Link)`
    display: block;

    background-color: transparent;
    outline: none;
    border: none;

    ${FontLight}
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 1px;
    text-transform: uppercase;
    text-decoration: none;

    color: ${Colors.black};

    transition: opacity 0.15s ease-out;

    &:hover {
        opacity: 0.5;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        font-size: 11px;
        line-height: 27px;
        letter-spacing: 2px;
    }
`